<template>
  <div v-if="!isMobile()">
    <div class="clear-filter" filter-color="">
      <div class="CarouselWrap">
        <carousel
          perPage="1"
          navigation-enabled="true"
          navigationNextLabel=""
          navigationPrevLabel=""
          
        >
          <slide class="info-slide">
            <section class="main-visual">
              <div class="main-visual-contents">
                <div class="main-visual-logo"><img v-lazy="'/img/renewal/main-visual-logo.png'" /></div>
                <div>
                  <div class="main-market-btn-wrap">
                    <img
                      v-lazy="'/img/renewal/img_appstore.png'"
                      @click="goAppstore()"
                    />
                    <img
                      v-lazy="'/img/renewal/img_googleplay.png'"
                      @click="goPlaystore()"
                    />
                  </div>
                  <div class="main-visual-btn-wrap">
                    <button
                      @click="goLand()"
                      class="main-visual-btn main-visual-btn1"
                    >
                      ENTER LAND PORTAL
                    </button>
                    <button
                      @click="goDSTDashboard()"
                      class="main-visual-btn main-visual-btn2"
                    >
                      DST DASHBOARD
                    </button>
                    <button
                      v-if="$i18n.locale != 'ko'"
                      @click="goGame()"
                      class="main-visual-btn main-visual-btn3"
                    >
                      PLAY NOW
                    </button>
                  </div>
                </div>
              </div>
              <div class="bg-wrap"></div>
              <video
                id="pc-bganimation"
                autoplay=""
                loop=""
                preload="auto"
                muted="muted"
              >
                <source src="/video/bg_pc.mp4?v=20220512" type="video/mp4" />
              </video>
            </section>
          </slide>
          
        </carousel>
      </div>
      <div class="main-box1">
        <div class="main-box-title-wrap" data-aos="fade-up">
          <div class="main-box-deco-wrap">
            <h2>ABOUT GAME</h2>
          </div>
        </div>
      </div>
      <div class="main-box2">
        <div class="main-video-wrap">
          <iframe
            width="100%"
            height="100%"
            id="ytplayer"
            allowfullscreen
            frameborder="0"
            src="https://www.youtube.com/embed/a1CWQgom4P8"
          ></iframe>
        </div>
        <div class="main-text-box">
          <h3>
            League of Kingdoms' is an MMO Strategy game where gamers fight for dominion.<br/>
            You can fully own and seamlessly trade digital assets through NFT technology.<br/>
            You will participate in game governance through transparent voting and congress system.
          </h3>
          <h4>
            LEAGUE OF KINGDOMS
          </h4>
        </div>
        <div class="main-guide-box">
          <ul>
            <li>
              <figure>
                <img src="/img/renewal/main_about_banner1.png" />
                <figcaption>
                  <h5>Fight for hegemony!</h5>
                  <p>
                    Build a strong kingdom and armies to overpower other<br />
                    kingdomsand monsters. Display your valor on the battlefield<br />
                    and secure your hegemony on the continent!
                  </p>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/main_about_banner2.png" />
                <figcaption>
                  <h5>Expand your alliance's territory!</h5>
                  <p>
                    Join an alliance or start your own with other kingdoms.<br />
                    Lead your alliance to victory.<br />
                    Expand your reach across the vast continent!
                  </p>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/main_about_banner3.png" />
                <figcaption>
                  <h5>Elect your leaders!</h5>
                  <p>
                    Elect your leaders through transparent blockchain voting.<br />
                    Voice your ideas to customize policies and take part<br />
                    in the making of democracy!
                  </p>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/main_about_banner4.png" />
                <figcaption>
                  <h5>CVC</h5>
                  <p>
                    Join the epic battle between several rival continents to conquer<br />
                    the Ancient Temple for $LOKA and various rewards!
                  </p>
                </figcaption>
              </figure>
            </li>
          </ul>
        </div>
      </div>
      <div class="main-box3">
        <div class="blockchain-feature-wrap">
          <div class="main-box-title-wrap" data-aos="fade-up">
            <div class="main-box-deco-wrap">
              <h2>BLOCKCHAIN FEATURES</h2>
            </div>
          </div>
          <ul class="blockchain-feature-list">
            <li>
              <figure>
                <img src="/img/renewal/blockchainfeatures_banner1.png" />
                <figcaption>
                  <h5>LAND</h5>
                  <p>
                    Claim your ownership of LANDs as digital estates
                    (NFT) and experience a new world of digital
                    ownership.  You can start earning rewards now!
                  </p>
                  <button
                    @click="goLandPage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <figcaption>
                  <h5>DRAGO</h5>
                  <p>
                    Adopt your Drago to start earning $DST!
                    Drago will accompany you throughout the
                    gameplay both in kingdom and in battle.
                  </p>
                  <button
                    @click="goDragoPage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
                <img src="/img/renewal/blockchainfeatures_banner2.png" />
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/blockchainfeatures_banner3.png" />
                <figcaption>
                  <h5>DRAGO EGG</h5>
                  <p>
                    Drago will be randomized when it hatches from the
                    egg. All eggs holds a small chance of getting the
                    Legendary Drago!
                  </p>
                  <button
                    @click="goDragoEggPage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <figcaption>
                  <h5>SKIN</h5>
                  <p>
                    Legendary and Mythic skins can be minted and
                    traded as NFTs. Show off your power by decorating
                    your castle with the skins.
                  </p>
                  <button
                    @click="goSkinPage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
                <img src="/img/renewal/blockchainfeatures_banner4.png" />
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/blockchainfeatures_banner5.png" />
                <figcaption>
                  <h5>RESOURCE</h5>
                  <p>
                    Mint and trade the resources to develop the
                    kingdom and raise the troops.
                    One of the largest trading market awaits you.
                  </p>
                  <button
                    @click="goResourecePage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <figcaption>
                  <h5>PACKAGE</h5>
                  <p>
                    Join social quests and events on Discord
                    and X to win the package NFTs to use in game.
                  </p>
                  <button
                    @click="goPackagePage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
                <img src="/img/renewal/blockchainfeatures_banner6.png" />
              </figure>
            </li>
          </ul>
        </div>
      </div>
      <div class="main-box4">
        <div class="partners-wrap">
          <div class="main-box-title-wrap" data-aos="fade-up">
            <div class="main-box-deco-wrap">
              <h2>INVESTORS & PARTNERS</h2>
            </div>
          </div>
            <ul>
                <li
                  v-for="(partner, index) in partners"
                  v-bind:key="index"
                >
                  <a v-bind:href="partner.url" target="_blank">
                    <img
                      v-bind:src="`/img/renewal/${partner.img}`"
                      width="100%"
                    />
                  </a>
                </li>
            </ul>
          </div>
      </div>
      <div class="main-box5">
        <div class="media-wrap">
          <div class="main-box-title-wrap" data-aos="fade-up">
            <div class="main-box-deco-wrap">
              <h2>NEWS & MEDIA</h2>
            </div>
          </div>
          <carousel
          perPage="3"
          navigation-enabled="true"
          navigationNextLabel=""
          navigationPrevLabel=""
          >
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다3페이지
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
    <!-- <trailer-section></trailer-section>
    <blockchain-section></blockchain-section>
    <partners-section></partners-section> -->
    
  </div>
  <div v-else>
    <!-- <div class="clear-filter" filter-color="black">
      <parallax
        class="page-header-image2"
        style="background-image: url('/img/img_m.png')"
      ></parallax>
      <div class="container" id="top">
        <div class="d-flex flex-column justify-content-lg-around">
          <img v-lazy="'/img/renewal/main-visual-logo.png'" />
          <div style="width: 60%; margin: auto">
            <div
              style="
                cursor: pointer;
              "
            >
              <img
                v-lazy="'/img/renewal/img_appstore.png'"
                style="cursor: pointer; width: 100%"
                @click="goAppstore()"
              />
              <img
                v-lazy="'/img/renewal/img_googleplay.png'"
                style="margin-top: 4%; cursor: pointer; width: 100%"
                @click="goPlaystore()"
              />
            </div>
            <img
              v-lazy="'/img/btn_land_m.png'"
              style="margin-top: 4%; cursor: pointer; width: 100%"
              @click="goLand()"
            />
          </div>
        </div>
      </div>
    </div> -->
    <div class="m-project">
      <div class="CarouselWrap">
          <carousel
            perPage="1"
            navigation-enabled="true"
            navigationNextLabel=""
            navigationPrevLabel=""
            loop="true"
          >
            <slide class="info-slide">
              <section class="main-visual">
                <div class="main-visual-contents">
                  <div class="main-visual-logo"><img v-lazy="'/img/renewal/main-visual-logo.png'" /></div>
                  <div>
                    <div class="main-market-btn-wrap">
                      <img
                        v-lazy="'/img/renewal/img_appstore.png'"
                        @click="goAppstore()"
                      />
                      <img
                        v-lazy="'/img/renewal/img_googleplay.png'"
                        @click="goPlaystore()"
                      />
                    </div>
                    <div class="main-visual-btn-wrap">
                      <button
                        @click="goLand()"
                        class="main-visual-btn main-visual-btn1"
                      >
                        ENTER LAND PORTAL
                      </button>
                      <button
                        @click="goDSTDashboard()"
                        class="main-visual-btn main-visual-btn2"
                      >
                        DST DASHBOARD
                      </button>
                      <button
                        v-if="$i18n.locale != 'ko'"
                        @click="goGame()"
                        class="main-visual-btn main-visual-btn3"
                      >
                        PLAY NOW
                      </button>
                    </div>
                  </div>
                </div>
                <div class="bg-wrap"></div>
                <video
                  id="pc-bganimation"
                  autoplay=""
                  loop=""
                  preload="auto"
                  muted="muted"
                >
                  <source src="/video/bg_pc.mp4?v=20220512" type="video/mp4" />
                </video>
              </section>
            </slide>
          
            
                
            
          </carousel>
      </div>
      <div class="main-box1">
        <div class="main-box-title-wrap" data-aos="fade-up">
          <div class="main-box-deco-wrap">
            <h2>ABOUT GAME</h2>
          </div>
        </div>
      </div>
      <div class="main-box2">
        <div class="main-video-wrap">
          <iframe
            width="100%"
            height="100%"
            id="ytplayer"
            allowfullscreen
            frameborder="0"
            src="https://www.youtube.com/embed/a1CWQgom4P8"
          ></iframe>
        </div>
        <div class="main-text-box">
          <h3>
            League of Kingdoms' is an MMO Strategy game where gamers fight for dominion.<br/>
            You can fully own and seamlessly trade digital assets through NFT technology.<br/>
            You will participate in game governance through transparent voting and congress system.
          </h3>
          <h4>
            LEAGUE OF KINGDOMS
          </h4>
        </div>
        <div class="main-guide-box">
          <ul>
            <li>
              <figure>
                <img src="/img/renewal/main_about_banner1.png" />
                <figcaption>
                  <h5>Fight for hegemony!</h5>
                  <p>
                    Build a strong kingdom and armies to overpower other<br />
                    kingdomsand monsters. Display your valor on the battlefield<br />
                    and secure your hegemony on the continent!
                  </p>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/main_about_banner2.png" />
                <figcaption>
                  <h5>Expand your alliance's territory!</h5>
                  <p>
                    Join an alliance or start your own with other kingdoms.<br />
                    Lead your alliance to victory.<br />
                    Expand your reach across the vast continent!
                  </p>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/main_about_banner3.png" />
                <figcaption>
                  <h5>Elect your leaders!</h5>
                  <p>
                    Elect your leaders through transparent blockchain voting.<br />
                    Voice your ideas to customize policies and take part<br />
                    in the making of democracy!
                  </p>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/main_about_banner4.png" />
                <figcaption>
                  <h5>CVC</h5>
                  <p>
                    Join the epic battle between several rival continents to conquer<br />
                    the Ancient Temple for $LOKA and various rewards!
                  </p>
                </figcaption>
              </figure>
            </li>
          </ul>
        </div>
      </div>
      <div class="main-box3">
        <div class="blockchain-feature-wrap">
          <div class="main-box-title-wrap" data-aos="fade-up">
            <div class="main-box-deco-wrap">
              <h2>BLOCKCHAIN FEATURES</h2>
            </div>
          </div>
          <ul class="blockchain-feature-list">
            <li>
              <figure>
                <img src="/img/renewal/m_blockchainfeatures_banner1.png" />
                <figcaption>
                  <h5>LAND</h5>
                  <p>
                    Claim your ownership of LANDs as digital estates<br />
                    (NFT) and experience a new world of digital <br />
                    ownership.  You can start earning rewards now!
                  </p>
                  <button
                    @click="goLandPage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <figcaption>
                  <h5>DRAGO</h5>
                  <p>
                    Adopt your Drago to start earning $DST!<br />
                    Drago will accompany you throughout the<br />
                    gameplay both in kingdom and in battle.
                  </p>
                  <button
                    @click="goDragoPage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
                <img src="/img/renewal/m_blockchainfeatures_banner2.png" />
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/m_blockchainfeatures_banner3.png" />
                <figcaption>
                  <h5>DRAGO EGG</h5>
                  <p>
                    Drago will be randomized when it hatches from the<br />
                    egg. All eggs holds a small chance of getting the <br />
                    Legendary Drago!
                  </p>
                  <button
                    @click="goDragoEggPage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <figcaption>
                  <h5>SKIN</h5>
                  <p>
                    Legendary and Mythic skins can be minted and<br />
                    traded as NFTs. Show off your power by decorating<br />
                    your castle with the skins.
                  </p>
                  <button
                    @click="goSkinPage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
                <img src="/img/renewal/m_blockchainfeatures_banner4.png" />
              </figure>
            </li>
            <li>
              <figure>
                <img src="/img/renewal/m_blockchainfeatures_banner5.png" />
                <figcaption>
                  <h5>RESOURCE</h5>
                  <p>
                    Mint and trade the resources to develop the<br />
                    kingdom and raise the troops.<br />
                    One of the largest trading market awaits you.
                  </p>
                  <button
                    @click="goResourecePage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <figcaption>
                  <h5>PACKAGE</h5>
                  <p>
                    Join social quests and events on Discord<br />
                    and X to win the package NFTs to use in game.
                  </p>
                  <button
                    @click="goPackagePage()"
                  ><span>Learn More</span><i></i></button>
                </figcaption>
                <img src="/img/renewal/m_blockchainfeatures_banner6.png" />
              </figure>
            </li>
          </ul>
        </div>
      </div>
      <div class="main-box4">
        <div class="partners-wrap">
          <div class="main-box-title-wrap" data-aos="fade-up">
            <div class="main-box-deco-wrap">
              <h2>INVESTORS & PARTNERS</h2>
            </div>
          </div>
            <ul>
                <li
                  v-for="(partner, index) in partners"
                  v-bind:key="index"
                >
                  <a v-bind:href="partner.url" target="_blank">
                    <img
                      v-bind:src="`/img/renewal/${partner.img}`"
                      width="100%"
                    />
                  </a>
                </li>
            </ul>
          </div>
      </div>
      <div class="main-box5">
        <div class="media-wrap">
          <div class="main-box-title-wrap" data-aos="fade-up">
            <div class="main-box-deco-wrap">
              <h2>NEWS & MEDIA</h2>
            </div>
          </div>
          <carousel
          perPage="1"
          navigation-enabled="true"
          navigationNextLabel=""
          navigationPrevLabel=""
          >
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
            <slide class="media-slide">
              <div>
                <figure>
                  <div class="media-thumb">
                    <img src="/img/renewal/main_about_banner1.png" />
                  </div>
                  <figcaption>
                    <h6>
                      제목이 노출됩니다3페이지
                    </h6>
                    <p>
                      내용이 노출됩니다
                    </p>
                    <span>날짜노출</span><em>MORE</em>
                  </figcaption>
                </figure>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
    <!-- <trailer-section></trailer-section>
    <blockchain-section></blockchain-section>
    <partners-section></partners-section> -->
    
  </div>
</template>
<script>
import { Parallax, Modal, Button } from "@/components";
import TrailerSection from "./components/TrailerSection";
import GameSection from "./components/GameSection";
import BlockchainSection from "./components/BlockchainSection";
import PartnersSection from "./components/PartnersSection";
import { Popover } from "element-ui";
import FlipCountdown from "./components/FlipCountdown";
import VueScreenSize from "vue-screen-size";
import config from "../config.js";
import axios from "axios";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "index",
  bodyClass: "index-page",
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
    Parallax,
    Modal,
    TrailerSection,
    GameSection,
    BlockchainSection,
    PartnersSection,
    FlipCountdown,
    Carousel,
    Slide
  },
  data() {
    return {
      width: 0,
      height: 0,
      startTime: new Date("2023-03-01 00:00:00Z").getTime(),
      day: 0,
      hour: 0,
      min: 0,
      sec: 0,
      saleStatus: false,
      eventStarted: false,
      saleHover: false,
      partners: [
        {
          url: "https://www.hashed.com/",
          img: "img-ip-01.png",
        },
        {
          url: "https://a16z.com/crypto/",
          img: "img-ip-02.png",
        },
        {
          url: "https://www.peakxv.com/",
          img: "img-ip-03.png",
        },
        {
          url: "https://labs.binance.com/",
          img: "img-ip-04.png",
        },
        {
          url: "https://www.blocktower.com/",
          img: "img-ip-05.png",
        },
        {
          url: "https://yieldguild.io/",
          img: "img-ip-06.png",
        },
        {
          url: "https://www.skyvisioncapital.com/",
          img: "img-ip-07.png",
        },
        {
          url: "https://despread.io/",
          img: "img-ip-08.png",
        },
        {
          url: "https://nodgames.com/",
          img: "img-ip-09.png",
        },
        {
          url: "https://opensea.io/",
          img: "img-ip-10.png",
        },
        {
          url: "https://www.sandbox.game/",
          img: "img-ip-11.png",
        },
        {
          url: "https://www.tokenpocket.pro/",
          img: "img-ip-12.png",
        },
        {
          url: "https://token.im/",
          img: "img-ip-13.png",
        },
        {
          url: "https://kyber.network/",
          img: "img-ip-14.png",
        },
        {
          url: "https://makerdao.com/",
          img: "img-ip-15.png",
        },
        {
          url: "https://trinito.co/",
          img: "img-ip-16.png",
        },
      ],
    };
  },
  computed: {},
  mounted: async function () {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.checkTimer();
    setInterval(() => {
      this.checkTimer();
    }, 1000);
  },
  beforeDestroy: function () {},
  methods: {
    checkTimer() {
      let now = new Date().getTime();
      if (now > this.startTime) {
        this.eventStarted = true;
        this.day = 0;
        this.hour = 0;
        this.min = 0;
        this.sec = 0;
        this.saleStatus = true;
      } else {
        this.eventStarted = false;
        this.saleStatus = false;
        let remain = this.startTime - now;
        this.day = Math.floor(remain / (24 * 60 * 60 * 1000));
        remain -= this.day * (24 * 60 * 60 * 1000);
        this.hour = Math.floor(remain / (60 * 60 * 1000));
        remain -= this.hour * (60 * 60 * 1000);
        this.min = Math.floor(remain / (60 * 1000));
        remain -= this.min * (60 * 1000);
        this.sec = Math.floor(remain / 1000);
      }
    },
    getZoomLevel() {
      return this.width / 1920.0;
    },
    handleResize(event) {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goGame: async function () {
      let url = "//play.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goEvent() {
      let url = "/event" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goMarketPlace() {
      let url = "//marketplace.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goAppstore: async function () {
      let url =
        "//apps.apple.com/us/app/league-of-kingdoms/id1523441842" +
        localStorage.urlParam;
      window.open(url, "_blank");
    },
    goPlaystore: async function () {
      let url =
        "//play.google.com/store/apps/details?id=com.nplusent.lok" +
        localStorage.urlParam;
      window.open(url, "_blank");
    },
    goLand: async function () {
      let url = "//land.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goDSTDashboard: async function () {
      let url = "//dst.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goGenesisSale() {
      this.$router.push("/genesis");
    },
    goAboutGenesis: async function () {
      let url =
        "//medium.com/league-of-kingdoms-eng/the-drago-genesis-guide-2278ebd7fb80";
      window.open(url, "_blank");
    },
    goDetail(idx) {
      switch (idx) {
        case 0:
          this.$router.push("/land");
          break;
        case 1:
          this.$router.push("/drago");
          break;
        case 2:
          this.$router.push("/arena");
          break;
      }
    },
    goLandPage() {
      let url = "//opensea.io/collection/lokland" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goDragoPage() {
      let url = "//tofunft.com/collection/drago/items" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goDragoEggPage() {
      let url ="//opensea.io/collection/dragoegg-2" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goSkinPage() {
      let url ="//opensea.io/collection/league-of-kingdoms-skin-polygon" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goResourecePage() {
      let url = "//tofunft.com/collection/league-of-kingdoms-item/items" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goPackagePage() {
      let url = "//opensea.io/collection/league-of-kingdoms-package" + localStorage.urlParam;
      window.open(url, "_blank");
    },
  },
};
</script>
<style>

/* 0819 리뉴얼 작업 //////////////////////////// start */

body .VueCarousel-navigation-button {
  outline: none !important;
}
.CarouselWrap .VueCarousel-navigation .VueCarousel-navigation-prev {
  left: 100px;
  width: 88px; height: 88px;
  background-color: rgb(0, 15, 44, 0.3);
  clip-path: polygon(10% 0%, 100% 0, 100% 0, 100% 90%, 90% 100%, 0 100%, 0 100%, 0% 10%);
  transition: all ease .1s;
}
.CarouselWrap .VueCarousel-navigation .VueCarousel-navigation-prev::after {
  content: '';
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
  display: block;
  width: 14px; height: 28px;
  background-image: url('/img/renewal/icon-arr-left.png');
}
.CarouselWrap .VueCarousel-navigation .VueCarousel-navigation-prev:hover {
  background-color: #000f2c;
  opacity: 1; transition: all ease .1s;
}
.CarouselWrap .VueCarousel-navigation .VueCarousel-navigation-prev:hover::after {
  background-image: url('/img/renewal/icon-arr-left-active.png');
}
.CarouselWrap .VueCarousel-navigation .VueCarousel-navigation-next {
  right: 100px;
  width: 88px; height: 88px;
  background-color: rgb(0, 15, 44, 0.3);
  clip-path: polygon(10% 0%, 100% 0, 100% 0, 100% 90%, 90% 100%, 0 100%, 0 100%, 0% 10%);
  transition: all ease .1s;
}
.CarouselWrap .VueCarousel-navigation .VueCarousel-navigation-next::after {
  content: '';
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
  display: block;
  width: 14px; height: 28px;
  background-image: url('/img/renewal/icon-arr-right.png');
}
.CarouselWrap .VueCarousel-navigation .VueCarousel-navigation-next:hover {
  background-color: #000f2c;
  opacity: 1; transition: all ease .1s;
}
.CarouselWrap .VueCarousel-navigation .VueCarousel-navigation-next:hover::after {
  background-image: url('/img/renewal/icon-arr-right-active.png');
}
.CarouselWrap .VueCarousel-pagination .VueCarousel-dot-container {
  position: absolute; left: 50%; bottom: 40px; transform: translate(-50%, -50%);
  font-size: 0;
}
.CarouselWrap .VueCarousel-pagination .VueCarousel-dot-container .VueCarousel-dot:focus {
  outline: none !important;
}
.CarouselWrap .VueCarousel-pagination .VueCarousel-dot-container .VueCarousel-dot {
  margin: 0 5px !important;
  padding: 0 !important; margin-top: 0 !important;
  border: 2px solid #fff; box-sizing: border-box !important;
  background-color: transparent !important;
}
.CarouselWrap .VueCarousel-pagination .VueCarousel-dot-container .VueCarousel-dot--active {
  padding: 0 !important; margin-top: 0 !important;
  box-sizing: border-box !important;
  background-color: #fff !important;
}
.main-visual {
  position: relative;
  width: 100%; height: 100vh;
  /* min-height: 1000px; */
}
.main-visual-contents {
  display: flex; align-items: center; justify-content: center; flex-direction: column;
  width: 100%; height: 100%;
  position: absolute; top: 0; left: 0;
  z-index: 11;
}
.main-visual-logo {
  margin: 0 0 80px;
}
.main-market-btn-wrap {
  display: flex; align-items: center; justify-content: center; gap: 10px;
  cursor: pointer;
}
.main-visual-btn-wrap {
  display: flex; align-items: center; justify-content: center; flex-direction: column;
  margin: 20px 0 0;
  gap: 10px;
}
.main-visual-btn {
  position: relative;
  width: 380px; height: 72px;
  border: 0;
  color: #fff; font-size: 20px; font-weight: 600; letter-spacing: -0.2px;
  clip-path: polygon(3% 0, 100% 0, 100% 0, 100% 84%, 97% 100%, 0 100%, 0 100%, 0 16%);
}
.main-visual-btn::after {
  content:'';
  display: block;
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
  width: 370px; height: 62px;
  background-image: url('/img/renewal/main_btn_line.png');
  mix-blend-mode: soft-light;
}
.main-visual-btn1 {
  background-color: rgb(29, 32, 43, 0.8);
}
.main-visual-btn2 {
  background-color: rgb(0, 195, 193, 0.8);
}
.main-visual-btn3 {
  background-color: rgb(54, 0, 255, 0.8);
}
.main-visual-btn:hover {
  clip-path: polygon(0 0, 100% 0, 100% 0, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0);
  transition: clip-path .2s;
}
.main-visual-btn:hover::after {
  background: none;
}
.main-visual .bg-wrap {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%;
    background-color: rgba(0,0,0,.3);
    /*
    background-image: radial-gradient(rgba(0,0,0,.1) 1px, transparent 0);
    background-size: 5px 5px;
    background-position: -19px -19px;
    */
    z-index: 10;
}
.main-visual video {
  position: absolute; top: 0; left: 0;;
  display: block;
  width: 100%; height: 100%;
  /* height: 100vh; */
  outline: 0;
  object-fit: cover;
}
.main-box-title-wrap {
  margin: 0 0 78px;
}
.main-box-deco-wrap {
  position: relative;
  display: flex; justify-content: center;
  height: 40px;
  background-image: url('/img/renewal/main_deco1.png');
  background-repeat: no-repeat;
  background-position: 49.5%;
}
.main-box-deco-wrap h2 {
  position: absolute; top: 0; left: 50%; transform: translateX(-50%);
  color: #080f3a; font-size: 32px; font-weight: 700; letter-spacing: -0.32px;
}
.main-box1 {
  margin: 150px 0 0;
}
.main-box2 .main-video-wrap {
  display: flex; align-items: center; justify-content: center;
  margin: 0 0 40px;
}
.main-box2 iframe {
  width: 1280px; height: 720px;
}
.main-box2 .main-text-box {
  display: flex; align-items: center; justify-content: center; flex-direction: column;
}
.main-box2 .main-text-box h3 {
  line-height: 1.6;
  margin: 0;
  color: #252e38; font-size: 22px; font-weight: 500; letter-spacing: -0.22px;
  text-align: center;
}
.main-box2 .main-text-box h4 {
  position: relative;
  margin: 0;
  color: #f8f8fa; font-size: 156px; font-weight: 800; letter-spacing: -1.56px;
  text-align: center;
}
.main-box2 .main-text-box h4::after {
  content: '';
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
  display: block;
  width: 44px; height: 62px;
  background-image: url('/img/renewal/main-icon1.png');
  background-repeat: no-repeat;
  background-position: 50%;
}
.main-box2 .main-guide-box {
  display: flex; justify-content: center;
  padding: 0 0 100px;
  background-image: url('/img/renewal/main_bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 100px;
}
.main-box2 .main-guide-box ul {
  display: grid;
  height: 1120px;
  grid-template-columns: 632px 632px;
  grid-column-gap: 10px;
  grid-row-gap: 40px;
}
.main-box2 .main-guide-box ul li {
  display: flex; align-items: flex-start; justify-content: center;
  /* background-color: #f8899b; */
}
.main-box2 .main-guide-box ul li figure {
  position: relative;
  display: flex; flex-direction: column;
  height: 540px;
  margin: 0;
}
.main-box2 .main-guide-box ul li figure::before {
  content: ''; 
  position: absolute; top: 5px; left: 50%; transform: translateX(-50%);
  display: block;
  width: 576px; height: 355px;
  border: 1px solid #736A06; opacity: 0.5;
  z-index: 10;
}
.main-box2 .main-guide-box ul li figure::after {
  content:'';
  position: absolute; top: 10px; left: 50%; transform: translateX(-50%);
  display: block;
  width: 588px; height: 349px;
  border: 1px solid #8E8308;
  z-index: 9;
}

.main-box2 .main-guide-box ul li img {
  clip-path: polygon(5% 0, 100% 0, 100% 0, 100% 94%, 100% 100%, 0 100%, 0 100%, 0 8%);
}
.main-box2 .main-guide-box ul li figcaption {
  position: absolute; bottom: 0; left: 50%; transform: translateX(-50%);
  width: 632px; height: 220px;
  background-image: url('/img/renewal/main_about_info_bg.png');
  z-index: 11;
}
.main-box2 .main-guide-box ul li figcaption h5 {
  background-image: url('/img/renewal/main_deco2.png');
  background-repeat: no-repeat; background-position: 50% 50px;
  margin: 50px 0 0; padding: 0 0 30px;
  color: #fff; font-size: 22px; font-weight: 600; letter-spacing: -0.22px;
  text-align: center;
}
.main-box2 .main-guide-box ul li figcaption p {
  margin: 16px 0 0;
  color: #fff; font-size: 15px; font-weight: 500; text-align: center;
}
.main-box3 .blockchain-feature-wrap {
  padding: 100px 0;
  background-color: #4306aa;
}
.main-box3 .blockchain-feature-wrap ul {
  width: 1320px;
  margin: 0 auto; padding: 0 20px;
}
.main-box3 .main-box-deco-wrap {
  background-image: url('/img/renewal/main_deco3.png');
}
.main-box3 .main-box-deco-wrap h2 {
  color: #fff;
}
.blockchain-feature-list li {
  display: flex; align-items: center; justify-content: space-between;
  margin: 0 0 60px;
}
.blockchain-feature-list li figure {
  width: 100%;
  display: flex; align-items: flex-start; justify-content: space-between;
}
.blockchain-feature-list li figure figcaption {
  margin: 0 0 0 40px;
}
.blockchain-feature-list li figure figcaption h5 {
  line-height: 1.2;
  color: #fff; font-size: 48px; font-weight: 700; letter-spacing: -0.48px;
}
.blockchain-feature-list li figure figcaption p {
  line-height: 1.8;
  margin: 0 0 60px;
  color: #fff; font-size: 18px; font-weight: 500; letter-spacing: -0.18px;
}
.blockchain-feature-list li figure figcaption button {
  position: relative;
  display: block;
  width: 380px; 
  height: 72px;
  padding: 0 0 0 40px;
  border: 0;
  background: #fff;
  clip-path:
    polygon(
        0% 10px,                 /* top left */
        10px 0%,                 /* top left */
        calc(100% - 10px) 0%,    /* top right */
        100% 0,               /* top right */
        100% calc(100% - 10px),  /* bottom right */
        calc(100% - 10px) 100%,  /* bottom right */
        0 100%,               /* bottom left */
        0 calc(100% - 10px)      /* bottom left */
  );
  transition: clip-path .2s;
}
.blockchain-feature-list li figure figcaption button::after {
  content: "";
    position: absolute;
    top: 3px;
    right: 3px;
    left: 3px;
    bottom: 3px;
    background-color: #4306aa;
    clip-path:
    polygon(
        0% 8px,                 /* top left */
        8px 0%,                 /* top left */
        calc(100% - 8px) 0%,    /* top right */
        100% 0,               /* top right */
        100% calc(100% - 8px),  /* bottom right */
        calc(100% - 8px) 100%,  /* bottom right */
        0 100%,               /* bottom left */
        0 calc(100% - 8px)      /* bottom left */
    );
}
.blockchain-feature-list li figure figcaption button:hover {
  clip-path:
    polygon(
        0% 0,                 /* top left */
        10px 0%,                 /* top left */
        calc(100% - 10px) 0%,    /* top right */
        100% 0,               /* top right */
        100% calc(100% - 0px),  /* bottom right */
        calc(100% - 10px) 100%,  /* bottom right */
        0 100%,               /* bottom left */
        0 calc(100% - 10px)      /* bottom left */
  );
  transition: clip-path .2s;
}
.blockchain-feature-list li figure figcaption button:hover::after {
  clip-path:
    polygon(
        0% 0,                 /* top left */
        10px 0%,                 /* top left */
        calc(100% - 10px) 0%,    /* top right */
        100% 0,               /* top right */
        100% calc(100% - 0px),  /* bottom right */
        calc(100% - 10px) 100%,  /* bottom right */
        0 100%,               /* bottom left */
        0 calc(100% - 10px)      /* bottom left */
  );
  transition: clip-path .2s;
}
.blockchain-feature-list li figure figcaption button span {
  position: absolute; top: 50%; left: 40px; transform: translateY(-50%);
  color: #fff; font-size: 24px; font-weight: 600;
  z-index: 100;
}
.blockchain-feature-list li figure figcaption button i {
  position: absolute; top: 50%; right: 40px; transform: translateY(-50%);
  display: block;
  width: 24px; height: 18px;
  background-image: url('/img/renewal/main_arrow.png');
  z-index: 100;
}
.blockchain-feature-list li:nth-child(1) figure figcaption {
  margin: 30px 0 0 40px;
}
.blockchain-feature-list li:nth-child(1) figure img {
  margin-left: -20px;
}
.blockchain-feature-list li:nth-child(2) figure figcaption {
  margin: 55px 60px 0 0;
}
.blockchain-feature-list li:nth-child(2) figure img {
  margin-right: -26px;
}
.blockchain-feature-list li:nth-child(3) figure figcaption {
  margin: 55px 0 0 40px;
}
.blockchain-feature-list li:nth-child(3) figure img {
  margin-left: -26px;
}
.blockchain-feature-list li:nth-child(4) figure figcaption {
  margin: 55px 40px 0 0;
}
.blockchain-feature-list li:nth-child(4) figure img {
  margin-right: -26px;
}
.blockchain-feature-list li:nth-child(5) figure figcaption {
  margin: 55px 0 0 40px;
}
.blockchain-feature-list li:nth-child(5) figure img {
  margin-left: -26px;
}
.blockchain-feature-list li:nth-child(6) figure figcaption {
  margin: 55px 40px 0 0;
}
.blockchain-feature-list li:nth-child(6) figure img {
  margin-right: -26px;
}
.partners-wrap {
  display: flex; flex-direction: column;
  margin: 150px 0 160px;
}
.partners-wrap ul {
  display: grid;
  grid: repeat(4,160px) / repeat(4,308px);
  gap: 16px;
  margin: 0 auto; padding: 0; text-align: center;
}
.partners-wrap ul li {
  display: flex; align-items: center; justify-content: center;
  border-radius: 20px;
  background-color: #060b29;
}
.partners-wrap ul li a {
  display: flex; align-items: center; justify-content: center;
  width: 100%; height: 100%;
}
.partners-wrap ul li a img {
  width: auto; height: auto;
}
.media-wrap {
  padding: 100px 0 250px;
  background-color: #f4f5f8;
}
body .media-wrap .VueCarousel {
  width: 1281px;
  margin: 0 auto;
}
body .media-wrap .VueCarousel-navigation-button {
  top: 108px !important;
}
body .media-wrap .VueCarousel-navigation .VueCarousel-navigation-prev {
  left: -210px;
  width: 60px; height: 60px;
  border-radius: 50%; background-color: #fff;
  clip-path: none;
}
body .media-wrap .VueCarousel-navigation .VueCarousel-navigation-prev::after {
  content: '';
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
  display: block;
  width: 30px; height: 18px;
  background-image: url('/img/renewal/icon-arr-left2.png');
  background-repeat: no-repeat;
  background-position: 50%;
}
body .media-wrap .VueCarousel-navigation .VueCarousel-navigation-next {
  right: -210px;
  width: 60px; height: 60px;
  border-radius: 50%; background-color: #fff;
  clip-path: none;
}
body .media-wrap .VueCarousel-navigation .VueCarousel-navigation-next::after {
  content: '';
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
  display: block;
  width: 30px; height: 18px;
  background-image: url('/img/renewal/icon-arr-right2.png');
  background-repeat: no-repeat;
  background-position: 50%;
}
body .media-wrap .VueCarousel-pagination .VueCarousel-dot-container {
  display: flex; align-items: center; justify-content: center;
  position: absolute; left: 50%; bottom: -80px; transform: translateX(-50%);
}
body .media-wrap .VueCarousel-pagination .VueCarousel-dot-container .VueCarousel-dot {
  width: 12px !important; height: 12px !important;
  margin: 0 10px !important; padding: 0 !important;
  border: 0; background-color: #000 !important;
  opacity: .1;
}
body .media-wrap .VueCarousel-pagination .VueCarousel-dot-container .VueCarousel-dot--active {
  width: 16px !important; height: 16px !important;
  border-color: #3402ed !important;
  background-color: #3402ed !important;
  opacity: 1 !important;
}
.media-wrap .media-slide figure .media-thumb {
  width: 400px; height: 220px;
}
.media-wrap .media-slide figure .media-thumb img {
  width: 100%; height: 100%;
}
.media-wrap .media-slide figure figcaption h6 {
  margin: 20px 0 0;
  color: #0e0e0e; font-size: 24px; font-weight: 700; letter-spacing: -0.24px;
}
.media-wrap .media-slide figure figcaption p {
  margin: 20px 0 60px;
  line-height: 1;
  color: #7e838c; font-size: 16px; font-weight: 400;
}
.media-wrap .media-slide figure figcaption span {
  display: inline-block;
  padding: 0 20px 0 0;
  color: #a9aba8; font-size: 14px; font-weight: 400;
}
.media-wrap .media-slide figure figcaption em {
  font-style: normal;
  color: #a9aba8; font-size: 14px; font-weight: 400;
}
.main-box5  {
  display: none;
}
@media screen and (max-width: 1740px) {
  .main-box5 {
    display: none;
  }
  .main-box2 .main-text-box h4 {
    font-size: 90px;
  }
  .main-box2 .main-text-box h4::after {
    background-size: 70%;
  }
}
@media screen and (max-width: 1500px) {
  .main-box2 .main-text-box h4 {
    font-size: 90px;
  }
  .main-box2 .main-text-box h4::after {
    background-size: 70%;
  }
}
@media screen and (max-width: 1168px) {
  .main-box2 .main-text-box h4 {
    
  }
}
@media screen and (max-width: 991px){
  .main-box-deco-wrap,
  .main-box3 .main-box-deco-wrap {
    background-image: none;
  }
  .main-box2 iframe {
    width: 100%; height: 250px;
  }
  .main-box2 .main-video-wrap {
    margin: 40px;
  }
  .main-box2 .main-text-box {
    margin: 0 40px;
  }
  .main-box2 .main-text-box h3 {
    font-size: 12px;
  }
  .main-box2 .main-text-box h4 {
    font-size: 60px;
  }
  .main-box2 .main-text-box h4::after {
    background-size: 60%;
  }
  .main-box2 .main-guide-box ul {
    display: flex; flex-direction: column; height: auto;
  }
  .main-box3 .main-box-deco-wrap h2,
  .main-box-deco-wrap h2 {
    width: 100%;
    text-align: center;
  }
  .main-box3 .blockchain-feature-wrap ul {
    width: 100%;
  }
  .blockchain-feature-list li figure {
    flex-direction: column; align-items: center;
  }
  .blockchain-feature-list li:nth-child(1) figure img,
  .blockchain-feature-list li:nth-child(3) figure img,
  .blockchain-feature-list li:nth-child(5) figure img {
    margin-left: auto;
  }
  .blockchain-feature-list li:nth-child(1) figure, 
  .blockchain-feature-list li:nth-child(3) figure,
  .blockchain-feature-list li:nth-child(5) figure {
    align-items: flex-start;
  }
  .blockchain-feature-list li:nth-child(1) figure figcaption,
  .blockchain-feature-list li:nth-child(3) figure figcaption,
  .blockchain-feature-list li:nth-child(5) figure figcaption {
    margin: 0 0 0 40px;
  }
  .blockchain-feature-list li:nth-child(2) figure,
  .blockchain-feature-list li:nth-child(4) figure,
  .blockchain-feature-list li:nth-child(6) figure {
    align-items: flex-start;
  }
  .blockchain-feature-list li:nth-child(2) figure img,
  .blockchain-feature-list li:nth-child(4) figure img,
  .blockchain-feature-list li:nth-child(6) figure img {
    order: 1;
    margin: 0;
  }
  .blockchain-feature-list li:nth-child(2) figure figcaption,
  .blockchain-feature-list li:nth-child(4) figure figcaption,
  .blockchain-feature-list li:nth-child(6) figure figcaption {
    order: 2;
    margin: 0 0 0 40px;
  }
  .partners-wrap {
    margin: 40px 20px;
  }
  .partners-wrap ul {
    display: flex; flex-wrap: wrap; justify-content: center;
    padding: 0;
  }
  .partners-wrap ul li {
    width: 100%;
    flex-basis: calc(50% - 16px);
    min-height: 50%;
    height: 160px;
    padding: 20px;
    box-sizing: border-box;
  }
  body .media-wrap .VueCarousel-inner {
    gap: 20px;
  }
  body .media-wrap .VueCarousel {
    width: 100%;
  }
  .m-project .main-box2 .main-guide-box ul li {
  margin: 20px; 
  }
  .m-project .main-box2 .main-guide-box ul li figcaption {
    width: 100%; height: auto; padding: 0 0 30px;
    background-size: 100% 100%; background-repeat: no-repeat; background-position: 0;
  }
  .m-project .main-box2 .main-guide-box ul li figure {
    height: 400px;
  }
  .m-project .main-box2 .main-guide-box ul li figure::before {
    width: 95%; height: 230px;
  }
  .m-project .main-box2 .main-guide-box ul li figure::after {
    width: 98%; height: 230px;
  }
  .m-project .main-box2 .main-guide-box ul li figcaption h5 {
    font-size: 20px;
  }
  .m-project .main-box2 .main-guide-box ul li figcaption p {
    font-size: 12px
  }
  .m-project .blockchain-feature-list li figure figcaption button {
    width: 100%;
  }
}

/* 모바일 */
.m-project .main-visual-logo {
  width: 240px;
}
.m-project .VueCarousel-navigation {
  display: none;
}
.m-project .main-market-btn-wrap {
  flex-direction: column;
}
.m-project .main-box2 .main-video-wrap {
  margin: 20px;
}
.m-project .main-box2 .main-text-box {
  margin: 0 20px;
}
.m-project .main-box2 .main-text-box h4 {
  margin: 10px 0 0;
  font-size: 30px;
}
.m-project .main-box2 .main-text-box h4::after {
  background-size: 30%;
}
.m-project .main-box2 .main-guide-box ul li {
  margin: 20px; 
}
.m-project .main-box2 .main-guide-box ul li figcaption {
  width: 100%; height: auto;
  background-size: 100% 100%; background-repeat: no-repeat; background-position: 0;
}
.m-project .main-box2 .main-guide-box ul li figure {
  height: 400px;
}
.m-project .main-box2 .main-guide-box ul li figure::before {
  width: 95%; height: 230px;
}
.m-project .main-box2 .main-guide-box ul li figure::after {
  width: 98%; height: 230px;
}
.m-project .main-box2 .main-guide-box ul li figcaption h5 {
  font-size: 20px;
}
.m-project .main-box2 .main-guide-box ul li figcaption p {
  font-size: 12px
}
.m-project .blockchain-feature-list li figure figcaption p {
  font-size: 14px;
}
.m-project .partners-wrap ul li {
  flex-basis: calc(50% - 16px);
  min-height: 50%;
}
.m-project .media-wrap {
  padding: 50px 20px 125px;
}
.m-project .media-wrap .media-slide figure .media-thumb {
  width: 100%;
}
.m-project .media-wrap .VueCarousel-inner {
  gap: inherit;
}
.m-project .blockchain-feature-list li figure figcaption h5 {
  font-size: 32px;
}
.m-project .blockchain-feature-list li figure figcaption p {
  margin: 0 0 32px;
}
.m-project .blockchain-feature-list li figure figcaption button {
  width: 70%;
}
.m-project .blockchain-feature-list li:nth-child(1) figure figcaption, 
.m-project .blockchain-feature-list li:nth-child(3) figure figcaption,
.m-project .blockchain-feature-list li:nth-child(5) figure figcaption,
.m-project .blockchain-feature-list li:nth-child(2) figure figcaption,
.m-project .blockchain-feature-list li:nth-child(4) figure figcaption,
.m-project .blockchain-feature-list li:nth-child(6) figure figcaption {
  width: 100%;
  margin: 20px auto; padding: 0;
}
.m-project .main-box5 {
  display: none;
}


/* ////////////////// renewal 작업 end */

.DR_Sale-time-box {
  position: relative;
  margin-top: -40px;
  margin-left: calc(50% - 340px);
  width: 680px;
  height: 330px;
}

.DR_Sale-time-box-start {
  cursor: pointer;
  position: relative;
  margin-top: -40px;
  margin-left: calc(50% - 300px);
  width: 600px;
  height: 160px;
}

.DR_Sale-time-bg {
  position: absolute;
  left: 40px;
  top: 0px;
  width: 600px;
  height: 330px;
  padding: 12px;
  opacity: 0.7;
  border-radius: 10px;
  border: solid 0 #000;
  background-color: #202431;
}

.DR_Sale-time-bg-start {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 600px;
  height: 160px;
  opacity: 0.6;
  border-radius: 10px;
  border: solid 0 #000;
  background-color: #202431;
}

.DRAGO-GENESIS-SALE-HOME {
  position: absolute;
  top: 30px;
  left: 0px;
  width: 100%;
  background-image: linear-gradient(to right, #ffa921, #f4ff3f),
    linear-gradient(to bottom, #fff, #fff);
  font-size: 36px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.DR_Sale-time-box-start-hover {
  cursor: pointer;
  position: relative;
  margin-top: -40px;
  margin-left: calc(50% - 300px);
  width: 600px;
  height: 160px;
}

.DR_Sale-time-bg-start-hover {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 600px;
  height: 160px;
  opacity: 0.6;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0 rgba(0, 0, 0, 0.2);
  border: solid 0 #000;
  background-image: linear-gradient(to right, #00baff, #5b2afa);
}

.COMING-SOON {
  position: absolute;
  top: 80px;
  left: 0px;
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.line {
  position: absolute;
  top: 12px;
  left: 52px;
  width: 576px;
  height: 306px;
  opacity: 0.1;
  border-radius: 10px;
  border: solid 1px #fff;
}

.line-start {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 576px;
  height: 136px;
  opacity: 0.1;
  border-radius: 10px;
  border: solid 1px #fff;
}

.line-start-hover {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 576px;
  height: 136px;
  opacity: 0.1;
  border-radius: 10px;
  border: solid 1px #fff;
  background-color: #fff;
}

.--timer-box {
  position: absolute;
  top: 129px;
  left: 0px;
  width: 680px;
  height: 129px;
  padding-left: 40px;
}

.--timer-bg {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 680px;
  height: 129px;
  border-radius: 16px;
  opacity: 0.7;
  box-shadow: 0px 10px 10px 0 rgba(0, 0, 0, 0.2);
  border: solid 0 #000;
  background-color: #fff;
}

.timer-box {
  position: absolute;
  top: 25px;
  width: 150px;
  height: 80px;
}

.time {
  width: 100%;
  height: 40px;
  font-family: Poppins;
  text-align: center;
  font-size: 40px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.05;
  letter-spacing: -1px;
  text-align: center;
  color: #202431;
}

.time_head {
  width: 100%;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 3;
  letter-spacing: -0.35px;
  text-align: center;
  color: #202431;
}

.DRAGO-GENESIS-SALE-TEXT {
  position: absolute;
  width: 100%;
  padding-top: 52px;
  background-image: linear-gradient(to right, #00c6ff, #28ff83);
  font-size: 36px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.DRAGO-GENESIS-SALE-TEXT-HOVER {
  position: absolute;
  width: 100%;
  padding-top: 52px;
  font-size: 36px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}
</style>
